<template>
  <div class="wrap">
    <img src="https://p1.ssl.qhimg.com/t110b9a9301d455f6a95ca03b51.png" alt="" class="wrapLogo" />
    <div class="wrapList">
      <div
        :class="{ active: selectedKey === item.key }"
        class="wrapListItem"
        @click="handleClick(item.href, item.key, item.routePath, item.path)"
        v-for="item in menu"
        :key="item.key"
      >
        <a href="javascript:void(0);">{{ item.title }}</a>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref } from 'vue'

const selectedKey = ref('home')
const menu = [
  {
    key: 'home',
    title: '首页',
    href: '#home'
  },
  {
    key: 'agenda',
    title: '日程',
    path: '/new/2024/agenda.html'
  },
  {
    key: 'guest',
    title: '嘉宾',
    routePath: 'new/2024/guest.html'
  },
  {
    key: 'activity',
    title: '活动',
    href: '#activity'
  },
  {
    key: 'news',
    title: '新闻中心',
    href: '#news'
  },
  {
    key: 'ticket',
    title: '购票链接',
    path: 'https://isc.360.com/2024/ticket'
  },
  {
    key: 'previous',
    title: '往届回顾',
    path: 'https://isc.360.com/new/events/history.html'
  }
  // {
  //   key: 'previous',
  //   title: '往届回顾',
  //   herf: '#previous'
  // }
]

const changeColor = (key) => {
  selectedKey.value = key
}

const handleClick = (href, key, routePath, path) => {
  // changeColor(key)
  if(href) {
    scrollToSection(href)
  } else if(path) {
    window.open(path, '_blank')
  }else if(routePath){
    const path = `${window.location.origin}/${routePath}`
    window.open(path)
  }
}

const scrollToSection = (href) => {
  const element = document.querySelector(href)
  if (element) {
    window.scrollTo({
      top: element.offsetTop,
      behavior: 'smooth'
    })
  }
}
</script>

<style lang="scss" scoped>
.wrap {
  width: 90%;
  position: fixed;
  min-width: 1230px;
  // width: calc(100vw - 320px);
  // min-width: 833px;
  // position: absolute;
  z-index: 1000;
  top: 32px;
  left: 50%;
  transform: translateX(-50%);
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 17px 48px;
  border-radius: 121px;
  background: rgba(255, 255, 255, 0.9);
  border: 1px solid #e8eaed;

  &Logo {
    width: 223px;
  }
  &List {
    &Item {
      display: inline-block;
      margin-right: 65px;
      a {
        font-size: 20px;
        font-weight: bold;
        /* Gray 中性/gray-9 */
        color: #242933;
      }
      a:hover {
        color: #497ced;
      }
    }
    &Item:last-child {
      margin: 0;
    }
  }
}
</style>
